import { Component, computed, inject } from '@angular/core';
import { RxIconModule } from '@nrwl/rx-icon';
import { LaserTreatmentControlDisplay } from './laser-treatment-control-display';
import { rxResource } from '@angular/core/rxjs-interop';
import { LaserService } from './laser-service';
import { RX_APP_CONTEXT, RxAppContext } from '@nrwl/rx-root-state';

/**
 * Placeholder for the Laser widget in the form designer.
 */
@Component({
  selector: 'fb-laser-widget-placeholder',
  imports: [LaserTreatmentControlDisplay, RxIconModule],
  templateUrl: './laser-widget-placeholder.html',
  styleUrl: './laser-widget-placeholder.scss',
})
export class LaserWidgetPlaceholder {
  private readonly appContext = inject(RX_APP_CONTEXT);
  private readonly laserService = inject(LaserService);

  /**
   * Company details.
   */
  protected readonly company = rxResource({
    request: () => {
      if (this.isRxStaffContext) {
        return undefined;
      }

      return {};
    },
    loader: () => this.laserService.getCompany(),
  });

  /**
   * Labels for the laser treatment control.
   */
  protected readonly labels = computed(() => {
    if (this.company.hasValue()) {
      return this.company.value();
    }

    return {
      smartCoolText: null,
      joulesText: null,
      pulseText: null,
      repetitionRateText: null,
      firstLaserOptionText: null,
      secondLaserOptionText: null,
    };
  });

  private get isRxStaffContext(): boolean {
    return this.appContext === RxAppContext.RxStaff;
  }
}
